import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/staff`;

export const getToken = () => localStorage.getItem("vops_token");
export const getProfile = () => {
  try { return JSON.parse(localStorage.getItem("vops_profile") || "null"); } catch { return null; }
};
export const setAuth = (token, profile) => {
  localStorage.setItem("vops_token", token);
  localStorage.setItem("vops_profile", JSON.stringify(profile));
};
export const clearAuth = () => {
  localStorage.removeItem("vops_token");
  localStorage.removeItem("vops_profile");
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};

export const photoUrl = (id) => `${API}/photos/${id}?token=${getToken()}`;
export const exportUrl = (type) => `${API}/manager/export?type=${type}&token=${getToken()}`;
export const weekPdfUrl = () => `${API}/manager/week-overview.pdf?token=${getToken()}`;
export async function downloadCsv(path, params = {}, filename = "export.csv") {
  const { data } = await api.get(`/${path}`, { params: { ...params, format: "csv" }, responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function uploadPhoto(file, ref = "task") {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("ref", ref);
  const { data } = await api.post("/photos", fd);
  return data.photo_id;
}
